var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCoinbasePay = function SvgCoinbasePay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0043 16.9223C9.28497 16.9223 7.08304 14.7193 7.08304 11.9999C7.08304 9.28057 9.28609 7.07865 12.0043 7.07865C14.4403 7.07865 16.463 8.85497 16.8528 11.1801H21.811C21.3922 6.12665 17.1642 2.15625 12.0043 2.15625C6.57008 2.15625 2.16064 6.56569 2.16064 11.9999C2.16064 17.4342 6.57008 21.8436 12.0043 21.8436C17.1642 21.8436 21.3933 17.8732 21.811 12.8198H16.8483C16.4586 15.146 14.4403 16.9223 12.0043 16.9223Z",
    fill: "#0052FF"
  })));
};

export { SvgCoinbasePay as ReactComponent };
export default __webpack_public_path__ + "d00fe8f5202581a49d3e442c3c4d0d8c.svg";